/**
 *
 * Qlist
 *
 */

import { mapGetters } from 'vuex';

import Paginate from 'vuejs-paginate';

import { HtmlMixin } from '@/mixins/MtEditor/HtmlMixin';
import { PageNoMixin } from '@/scripts/QA/QuestionList/mixins/PageNoMixin';

import { QA_QUESTION_LIST_PAGE } from '@/constants/routes';
import { PAGE_SIZE } from '@/scripts/QA/QuestionList/QuestionList.constants';

export default {
  name: 'QaSearchList',

  mixins: [HtmlMixin, PageNoMixin],

  components: {
    Paginate,
  },

  computed: {
    ...mapGetters('QA/QuestionList', {
      mg_searchTotal: 'searchTotal',
      mg_searchQaList: 'searchQaList',
    }),

    c_searchPageCount() {
      return Math.ceil(this.mg_searchTotal / PAGE_SIZE);
    },

    c_isShowPaginate() {
      return this.c_searchPageCount > 0;
    },
  },

  methods: {
    goBack() {
      this.$router.push(QA_QUESTION_LIST_PAGE);
    },

    handleSearchPageChange(pageNo) {
      this.$emit('search-page-change', pageNo);
    },
  },
};
